import { useState } from 'react';
import s from '../../styles/components/redeem/RedeemCodeEntry.module.css';

export default function RedeemCodeEntry({ ui, onSuccess }) {
  const [code, setCode] = useState('');
  const [error, setError] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (code === '1234') {
      onSuccess();
    } else {
      setError(true);
      setCode('');
    }
  };

  return (
    <div className={s.wrap}>
      <span className={s.eyebrow}>{ui.eyebrow}</span>
      <h2 className={s.headline}>{ui.headline}</h2>
      <p className={s.instruction}>{ui.instruction}</p>

      <form onSubmit={handleSubmit} className={s.form}>
        <input
          className={`${s.input} ${error ? s.inputError : ''}`}
          type="number"
          maxLength={4}
          placeholder={ui.placeholder}
          value={code}
          onChange={(e) => { setCode(e.target.value); setError(false); }}
          autoComplete="off"
        />
        {error && <p className={s.error}>{ui.errorMessage}</p>}
        <button type="submit" className={s.btn}>{ui.submitBtn}</button>
      </form>
    </div>
  );
}